<template>
  <div class="color-picker">
    <div class="mr-4" style="width: calc(100% - 28px)">
      <el-input placeholder="请选择" size="small" v-model="color" clearable
                @change="$emit('update:modelValue', color)"/>
    </div>
    <el-color-picker size="small" show-alpha v-model="color" id="picker"
                     @change="$emit('update:modelValue', color)"/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      color: this.modelValue
    }
  },
  props: {
    modelValue: {
      default: ''
    }
  },
  watch: {
    // 当前颜色选择器在操作切换组件的时候不会被销毁, 导致值污染，暂时处理为每次直接从props里面取
    modelValue(val) {
      if (Object.prototype.toString.call(val) === '[object Object]') {
        this.color = val.color
      } else {
        this.color = val
      }
    }
  },
  beforeMount() {
    if (Object.prototype.toString.call(this.modelValue) === '[object Object]') {
      this.color = this.modelValue.color
    }
  },
}
</script>

<style>
.color-picker {
  display: flex;
  width: 100%;

  #picker {

  }
}
</style>